import React, { useState , useEffect} from 'react'
import MUIDataTable from "mui-datatables";
import Container from '@mui/material/Container';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
// para la seleccion de fechas
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
//
//import { Button } from '@mui/base';
import Button from '@mui/material/Button';

function InscripcionesConsulta() {
    const [inscripciones,setInscripciones] = useState([]);
    const columns = ["provincia","localidad",{name: "fecha"},"hora","comercio","centro","calle","numero","apellido","nombre", "dni", "email","telefono","vendedor"
    ]

    const [provincias,setProvincias] = useState([]);
    const [localidades,setLocalidades] = useState([]);
    const [selectedOptionProvincia, setSelectedOptionProvincia] = useState(null);
    const [selectedOptionLocalidad, setSelectedOptionLocalidad] = useState(null);
    const [fechaInicial,setFechaInicial] = useState(null);
    const [fechaFinal,setFechaFinal] = useState(null);
    

const options = {
    textLabels: {
      body: {
        noMatch: "Lo siento, no se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: column => `Ordenar por ${column.label}`
      },
      pagination: {
        next: "Siguiente Página",
        previous: "Anterior Página",
        rowsPerPage: "Filas por Página:",
        displayRows: "de"
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver Columnas",
        filterTable: "Filtrar Tabla"
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "REINICIAR"
      },
      viewColumns: {
        title: "Mostrar Columnas",
        titleAria: "Mostrar/Ocultar Columnas"
      },
      selectedRows: {
        text: "fila(s) seleccionada(s)",
        delete: "Eliminar",
        deleteAria: "Eliminar filas seleccionadas"
      }
    }
};

const handleOptionChangeLocalidades = (event , value) => {
  //  event.preventDefault();
   // console.log(value);
    if (value !== null) {
        setSelectedOptionLocalidad(value.localidad);

          if (selectedOptionProvincia !== null && selectedOptionLocalidad !== null)
            {
  //setSeleccionados(true)
}
        else
        {
  //  setSeleccionados(false)
  
      } }
    else
    { //setSeleccionados(false)
    }

  }
    const handleOptionChangeProvincias = (event, value) => {
      setSelectedOptionProvincia(value.provincia);
      // cambio las localidad segun la provincia selecconada
      
      if (value != null) {
        getLocalidades(value.provincia);
            setLocalidades(value.provincia);
      }
      else {
        setLocalidades([]);
      }
    }

    const getLocalidades = (selected) => {
      const baseURL = process.env.REACT_APP_SERVER_PATH  + 'getLocalidades/'+selected;
      fetch(`${baseURL}`)
      .then(res => res.json())
      .then(
        (result) => { setLocalidades(result) 
        },
        (error) => {
        }
      )
     }

   const getProvincias = () => {
      const baseURL = process.env.REACT_APP_SERVER_PATH  + 'getProvincias';
      fetch(`${baseURL}`)
      .then(res => res.json())
      .then(
        (result) => { setProvincias(result) 
        },
        (error) => {
        }
      )
   }

   const handleDateInicialChange = (fecha) => {
    setFechaInicial(fecha.toISOString());
  };

  const handleDateFinalChange = (date) => {
    setFechaFinal(date.toISOString());
  };

  const getComercios = () => {
    const baseURL = process.env.REACT_APP_SERVER_PATH  + 'inscripcionesTodos/'+selectedOptionProvincia+'/'+selectedOptionLocalidad+'/'+fechaInicial+'/'+fechaFinal;
    fetch(`${baseURL}`)
    .then(res => res.json())
    .then(
      (result) => { setInscripciones(result) 
      },
      (error) => {
      }
    )
 }

  const filtrar = () => {
       getComercios() 
  }

useEffect(() => {
  getProvincias();  

       
},[])

  return (
    <Container component="main" maxWidth="lg" style={{ marginTop: "20px", marginBottom: "35px"}}>
          <Grid container spacing={1}>
      <Grid item xs={6} >
          <Autocomplete sx = {{mt : 2}}
                      id="auto"
                      options={provincias}
                      getOptionLabel={(provincias) => provincias.provincia}
                      renderInput={(params) => <TextField {...params} label="Provincia" variant="outlined" />}
                      onChange={handleOptionChangeProvincias}
                      />
      </Grid>
      <Grid item xs={6} >
          <Autocomplete sx = {{mt : 2}}
              id="auto"
              options={localidades}
              getOptionLabel={(localidades) => localidades.localidad}
              renderInput={(params) => <TextField {...params} label="Localidad" variant="outlined" />}
              onChange={handleOptionChangeLocalidades}
              //onChange = {(e) => {setSelectedOptionLocalidad( e.target.value)}}
              />  
      </Grid>
      <Grid item xs={1} >
          <h5>F Incial</h5>
      </Grid>  
      <Grid item xs={5} >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker 
        value = {fechaInicial}
        onChange={handleDateInicialChange}
        format="DD/MM/YYYY"
        />
      </LocalizationProvider> 
    </Grid> 
    <Grid item xs={1} >
          <h5>F Final</h5>
      </Grid>                   
    <Grid item xs={5} >
        <LocalizationProvider dateAdapter={AdapterDayjs}>

        <DatePicker 
                value = {fechaFinal}
                onChange={handleDateFinalChange}
        format="DD/MM/YYYY"
        />
      </LocalizationProvider> 
    </Grid>
    <Grid item xs={2} >
    <Button variant="contained" color="primary" onClick={()=>filtrar()}>
            Filtrar
            </Button>
      </Grid>                    
    </Grid>

      {/* marginBottom: "35px" para que no se superpongo con el Footer */}
       <MUIDataTable
        title= {"Listado de Inscripciones"}
        data = {inscripciones}
        columns= {columns}
        options= {options}
        />
    </Container>
  )
}

export default InscripcionesConsulta